module.exports = __webpack_public_path__ + "img/extended.232618c8.png";